$(function () {
    if ($('main').hasClass('works')) {
        var swiper1 = {
            width: Infinity,
            swiperContainer: '.works-main__top-right',
            swiperContainerSlide: '.works-main__top-right a',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 500
            }
        }

        initCustomSwiper(swiper1)
        $(window).resize(function () {
            initCustomSwiper(swiper1)
        })
    }
})
$(document).ready(function () {
    let data = [];
    let category = 'all';
    let sort = 'new';

    if($('.works-main').length){
        $.ajax({
            url: '/ajax/get_works',
            dataType: 'JSON',
            type: 'POST',
            data: {
                _token: $('[name="csrf-token"]').attr('content')
            },
            success: function (jdata) {
                data = jdata.aWorks
                renderItems();
            },
            error: function (data) {}
        })
        function renderItems () {
            let sortFn = (a, b)=>0;
            if(sort == 'new') {
                sortFn = (a, b)=>{
                   if(a.publish_date>b.publish_date) return -1;
                   if(a.publish_date<b.publish_date) return 1;
                   return 0;
                };
            } else if(sort == 'rating') {
                sortFn = (a, b)=>{
                    if(a.likes<b.likes) return 1;
                    if(a.likes>b.likes) return -1;
                    return 0;
                };
            } else if(sort == 'name') {
                sortFn = (a, b)=>{
                    return a.title.localeCompare(b.title);
                };
            }

            let elements = data
                .filter(category=='all'?(el=>true):(el => el.filtr.indexOf(category) >= 0))
                .sort(sortFn)
                .map(el => {
                return `
        <a href="${
                    el.href
                }" class="works-main__item wow fadeIn ${el.card_class}" data-wow-delay="0.2s" data-wow-duration="0.6s" data-wow-offset="100"">
          <div class="works-main__item-title ">${el.title}</div>
          <div class="works-main__item-text">${el.text}</div>
          <div class="works-main__item-img">
            <img src="${el.src}" alt="${el.alt}" />
          </div>
          ${
                    el.soon === 'soon'
                        ? ' <div class="works-main__item-soon"> <img src="/img/works/soon-3.svg" alt="Скоро" />  </div>'
                        : ''
                }
          </a>
        `
            });
            $('.works-main__grid').html(elements);
        }

        $('[data-filtr]').on('click', function (e) {
            category = $(this).attr('data-filtr')
            e.preventDefault()
            var $this = $(this)
            $('[data-filtr]').removeClass('active')
            $this.addClass('active')
            renderItems();
        });

        $('.simple-select__list .simple-select__item').on('click', function (e) {
            sort = $(this).data('value');
            renderItems();
        });
    }
})
